import React from 'react';
import './Loader.css'

const Loader = () => {
    return (
        <div className='flex justify-center'>
            <span className="loader"></span>
        </div>
    );
};

export default Loader;